/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundParameters {
    getFixupPrototypeFunction() { return AIPlaygroundParameters.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundParameters>): AIPlaygroundParameters {
        let obj = Object.assign(new AIPlaygroundParameters(), model);
        AIPlaygroundParameters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundParameters>): AIPlaygroundParameters {
        if (!model) return null;
        return AIPlaygroundParameters.newInstance(<AIPlaygroundParameters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundParameters) {
        if (!obj) return;

        models.AIPlaygroundParameters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundParameters): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundParameters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.max_tokens === undefined) {
            this.max_tokens = 0;
        }
        if (this.temperature === undefined) {
            this.temperature = 0;
        }
        if (this.top_p === undefined) {
            this.top_p = 0;
        }
    }

    /**
     * Maximum response tokens
     */
    max_tokens: number;

    /**
     * Stop sequences
     */
    stop_sequences: Array<string>;

    /**
     * Sampling temperature
     */
    temperature: number;

    /**
     * Top P sampling value
     */
    top_p: number;

}
